import * as React from "react"
import { Box } from "@mui/material"

import { HierarchicalTextBlock, IconDataBlock, LabelCountry } from "@components"
import { CategoryText } from "../@components"


export default function retailerColumn() {
    return [{
        name: "gifts", label: "Has gifts?",
        options: {
            display: "excluded",
            filterType: "checkbox",
            customBodyRowRender: value => value ? "Yes" : "No"
        }
    }, {
        name: "richContent", label: "Has rich content?",
        options: {
            display: "excluded",
            filterType: "checkbox",
            customBodyRowRender: value => value ? "Yes" : "No"
        }
    }, {
        name: "stockOnline", label: "In Stock?",
        options: {
            display: "excluded",
            filterType: "checkbox",
            customBodyRowRender: value => value ? "Yes" : "No"
        }
    }, {
        name: "retailer", label: "Retailer info",
        options: {
            filter: false,
            setCellProps: () => ({ sx: {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                backgroundColor: "white",
                zIndex: "100",
                borderRight: "1px solid",
                borderColor: "divider"
            }}),
            setCellHeaderProps: () => ({ sx: {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 0,
                backgroundColor: "white",
                zIndex: "101 !important",
                borderRight: "1px solid",
                borderColor: "divider"
            }}),
            customBodyRowRenderLite: (value, { country, gifts, richContent, stockOnline }) => {
                const stockIcon = stockOnline ? "store" : "store-slash"
                const stockLabel = stockOnline ? "In Stock" : "Out of stock"
                const stockColor = stockOnline ? "success" : "error"

                const giftLabel = gifts ? "yes" : "no"
                const giftColor = gifts ? "success" : "error"

                const richContentLabel = richContent ? "yes" : "no"
                const richContentColor = richContent ? "success" : "error"

                return <Box display="flex" flexDirection="column">
                    <LabelCountry country={country} label={value} />
                    <HierarchicalTextBlock subtitle="Gifts? " subtitleValue={<CategoryText label={giftLabel} color={giftColor} />} />
                    <HierarchicalTextBlock subtitle="Rich content? " subtitleValue={<CategoryText label={richContentLabel} color={richContentColor} />} />
                    <IconDataBlock icon={stockIcon} value={stockLabel} iconProps={{ sx: { color: `${stockColor}.dark`} }} />
                </Box>
            }
        }
    }]
}